import { useMutation } from '@tanstack/react-query';

import { bopsApi } from '@Network';

interface DownloadFileParams {
  conversationId: string;
  timestamp: string;
  fileName: string;
}

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round((bytes / k ** i) * 100) / 100} ${sizes[i]}`;
};

export const useFileDownload = () => {
  const downloadFile = useMutation({
    mutationFn: async ({ conversationId, timestamp, fileName }: DownloadFileParams) => {
      // Get presigned URL from backend
      const response = await bopsApi.getFileDownloadUrl(conversationId, timestamp, fileName);

      // Create a temporary anchor element and trigger download
      const link = document.createElement('a');
      link.href = response.download_url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  });

  return {
    downloadFile,
    formatFileSize,
  };
};

export default useFileDownload;
